import { AttackStatus } from '../attack-status'
import { Role } from '@contrast-security-inc/base-types'
import { ApplicationImportance } from '../application-importance'
import { AgentLanguage } from '../agent-language'
import { GradeValue } from '../../graphql/schema/types/grade-value'

type Severity = 'critical' | 'high' | 'medium' | 'low' | 'note'
type Status =
  | 'reported'
  | 'suspicious'
  | 'confirmed'
  | 'notAProblem'
  | 'remediated'
  | 'fixed'
  | 'autoRemediated'

export const OPEN_STATUSES: Status[] = ['reported', 'suspicious', 'confirmed']

interface VulnerabilityAggregations {
  readonly total: number
  readonly open: number
}
type StatusBreakdown = { readonly [key in Status]?: number }
type SeverityBreakdown = {
  readonly [key in Severity]: StatusBreakdown & VulnerabilityAggregations
}

export type VulnerabilitySeverityBreakdown = SeverityBreakdown &
  VulnerabilityAggregations
export interface ApplicationLicense {
  readonly expiration: string
}

export interface CompliancePolicy {
  readonly id: string
  readonly name: string
}

export interface MetadataValue {
  readonly name: string
  readonly value: string
  readonly unique: boolean
  readonly type: 'STRING' | 'NUMERIC' | 'PERSON_OF_CONTACT'
  readonly subfields?: MetadataSubvalue[]
}

export interface MetadataSubvalue {
  readonly name: string
  readonly value: string
  readonly unique: boolean
  readonly type: 'CONTACT_NAME' | 'PHONE' | 'EMAIL'
}

export interface Application {
  readonly id: string
  readonly name: string
  readonly language: AgentLanguage
  readonly vulnerabilityBreakdown: VulnerabilitySeverityBreakdown
  readonly attackStatus: AttackStatus
  readonly hasAProtectedServer: boolean
  readonly license?: ApplicationLicense
  readonly attackTotal: number
  readonly role: Role
  readonly url: string
  readonly linesOfCode: string
  readonly importance: ApplicationImportance
  readonly technologies: string[]
  readonly lastActivity: string
  readonly online: boolean
  readonly archived: boolean
  readonly primary: boolean
  readonly moduleCount: number
  readonly violatedCompliancePolicies: CompliancePolicy[]
  readonly tags: string[]
  readonly customMetadataFields?: MetadataValue[]
  readonly scoreGrade: GradeValue
}

export interface InvalidCustomField {
  readonly id: string
  readonly validationType: string
}

export type ApplicationAggregationCategory =
  | 'scores'
  | 'servers'
  | 'languages'
  | 'technologies'
  | 'tags'
  | 'compliance'
  | 'openVulnSeverities'
  | 'environment'
  | 'appImportances'
